<template>
  <div class="is-syoukyuu edit-item" v-if="editingData && options">
    <div class="head"><b>昇給・昇給</b></div>
    <div class="item select-box-adjust">
      <div class="syoukyuu flex flex-align-center">
        <div class="head"><b>昇給</b></div>
        <div class="data">
          <select-box class="small" :options="options.boolean_type" v-model="editingData.is_syoukyuu" :disabled="disabled"></select-box>
          <p class="current-data">{{ currentData?.is_syoukyuu ? '有' : '無' }}</p>

        </div>
        <p v-if="editingData.is_syoukyuu" class="scale">（業績・評価による）</p>
      </div>

      <div class="syouyo flex flex-align-center">
        <div class="head"><b>賞与</b></div>
        <div class="data">
          <select-box class="small" :options="options?.boolean_type" v-model="editingData.is_syouyo" :disabled="disabled"></select-box>
          <p class="current-data">{{ currentData?.is_syoukyuu ? '有' : '無' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null,
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

.item {
  .head {
    margin-right: 10px;
  }
}
</style>
